import React from "react";
import { useAuth } from "../lib/auth";

function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map(s => s[0]).join("").toUpperCase();
}

export default function PageHeader({ title, subtitle, actions, testid }) {
  const { user } = useAuth();
  return (
    <div className="ach-page-head" data-testid={testid || "page-header"}>
      <div className="ach-page-head__titles">
        <h1 data-testid="page-title">{title}</h1>
        {subtitle && <p data-testid="page-subtitle">{subtitle}</p>}
      </div>
      <div className="ach-page-head__actions">
        {actions}
        {user && (
          <div className="ach-user-chip" data-testid="signed-in-chip">
            <span className="ach-user-chip__avatar">{initials(user.name)}</span>
            <span>{user.name} · {user.role}</span>
          </div>
        )}
      </div>
    </div>
  );
}
